import { Student, Class, Grade } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    classNo: 0,
    studentNo: 0,
    grades: [],
    classes: [],
    students: [],
    sendPostResult: {}
  },
  actions: {
    async fetchAllSchoolData({ commit }, options) {
      const [classNo, studentNo] = await Promise.all([
        Class.count({ status: 'running' }),
        Student.count({ status: 'active' })
      ])
      commit('changeState', { classNo, studentNo })
    },
    async fetchGradeData({ commit }) {
      try {
        let grades = await Grade.fetch({ _sort: 'gradeNumber:asc' })
        const promises = grades.map(async g => {
          const classNo = await Class.count({ grade: g.id, status: 'running' })
          const studentNo = await Student.count({ grade: g.id, status: 'active' })
          g.classNo = classNo
          g.studentNo = studentNo
          return g
        })
        grades = await Promise.all(promises)
        commit('changeState', { grades })
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchClassData({ commit }, params) {
      try {
        const classes = await Class.fetch({ ...params, _sort: 'title:asc' })
        commit('changeState', { classes })
      } catch (error) {
        alert.error(error)
      }
    },
    setPostResult({ commit, state }, isSuccess) {
      state.sendPostResult = { isSuccess }
    }
  },
  mutations: {
    setSelectedStudent(state, data) {
      state.students = data
    },
    deleteStudent(state, studentId) {
      const studentIndex = state.students.findIndex(student => student.id === studentId)
      if (studentIndex !== -1) {
        state.students.splice(studentIndex, 1)
      }
    }
  },
  getters: {
    allSchoolItems: ({ classNo, studentNo }) => {
      return [{ title: 'Toàn trung tâm', classNo, studentNo }]
    },
    students: state => state.students
  }
}
